import BaseTooltip from '@components/shared/BaseTooltip';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { Image } from '@repo/ui/src/components/Image';
import { Markdown } from '@repo/ui/src/components/Markdown';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { getButtonVariant } from '@repo/ui/src/components/Button/utils';
import { ImageProps, AmplienceButtonProps } from '@repo/ui/src/types';

export interface FlavorProps {
  buttons: Array<AmplienceButtonProps>;
  color: string;
  description: string;
  title: string;
  pairsWithIcons: Array<{
    icon: ImageProps;
    name: string;
  }>;
  woodImage: ImageProps;
  woodPelletsText: string;
  pairsWithText: string;
}

const WoodPelletFlavor = ({
  title,
  woodPelletsText,
  pairsWithText,
  description,
  pairsWithIcons,
  buttons,
  woodImage,
  color,
}: FlavorProps) => {
  const borderColor = color ? `${color}` : 'black';
  return (
    <div className="tw-flex tw-h-full tw-w-full">
      <div style={{ borderRight: `4px solid ${borderColor}` }} className="tw-h-full tw-w-[100px]">
        <div className="tw-h-[200px] tw-relative tw-w-[100px]">
          <Image
            src={buildImageSrc(woodImage, 900, 0, 0)}
            alt=""
            role="presentation"
            layout="fill"
            height={200}
            width={200}
            objectFit="cover"
            priority
          />
        </div>
      </div>
      <div className="tw-py-2 tw-pl-5 md:tw-pt-16 md:tw-pb-6 md:tw-pl-12 tw-flex tw-flex-col tw-justify-between">
        <h2 className="tra-text-web-heading-2 tw-pb-5">{title}</h2>
        <p className="tra-text-web-sub-1 tw-pb-5">{woodPelletsText}</p>
        <Markdown>{description}</Markdown>
        <div className="tw-flex-1" />
        <h3 className="tra-text-web-body-l tw-font-bold tw-normal-case">{pairsWithText}</h3>
        <ul role="list" className="tw-p-0 tw-m-0 tw-mb-6 tw-flex tw-flex-wrap tw-list-none">
          {pairsWithIcons?.map(
            (icon) =>
              icon && (
                <li key={icon.name}>
                  {/* @ts-expect-error missing props */}
                  <BaseTooltip text={icon.name}>
                    <img
                      src={buildImageSrc(icon.icon, 40, 0, 0)}
                      alt=''
                      className="tw-h-8 tw-opacity-80 md:tw-mr-2 md:tw-my-2"
                    />
                  </BaseTooltip>
                </li>
              ),
          )}
        </ul>

        <div className="tw-flex tw-flex-row tw-w-full">
          {buttons?.map((b: any, i) => (
            <div key={i} className="tw-mr-4 tw-justify-center">
              <Button
                as={Anchor}
                variant={getButtonVariant(b.style, b.icon)}
                size="small"
                {...b}
                {...b?.link}
              >
                {b?.link?.displayName}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WoodPelletFlavor;
